var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#3F83F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 7.66667C21.6407 7.66667 22.6667 8.69269 22.6667 9.95834V15.5818C22.2715 15.417 21.8527 15.2977 21.4167 15.2303V9.95834C21.4167 9.38304 20.9503 8.91667 20.375 8.91667H9.95834C9.38304 8.91667 8.91667 9.38304 8.91667 9.95834V20.375C8.91667 20.9503 9.38304 21.4167 9.95834 21.4167H15.2303C15.2977 21.8527 15.417 22.2715 15.5818 22.6667H9.95834C8.69269 22.6667 7.66667 21.6407 7.66667 20.375V9.95834C7.66667 8.69269 8.69269 7.66667 9.95834 7.66667H20.375Z",
    fill: "#3F83F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.1994L18.8914 11.8081C19.1355 11.564 19.5312 11.564 19.7752 11.8081C19.9972 12.0299 20.0173 12.3772 19.8357 12.6218L19.7752 12.6919L13.9419 18.5252C13.72 18.7472 13.3728 18.7673 13.1282 18.5857L13.0581 18.5252L10.5581 16.0252C10.314 15.7812 10.314 15.3855 10.5581 15.1414C10.7799 14.9195 11.1272 14.8993 11.3718 15.0809L11.4419 15.1414L13.5 17.1994Z",
    fill: "#3F83F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1667 20.5833C25.1667 23.1147 23.1147 25.1667 20.5833 25.1667C18.052 25.1667 16 23.1147 16 20.5833C16 18.052 18.052 16 20.5833 16C23.1147 16 25.1667 18.052 25.1667 20.5833ZM18.0833 20.1667C17.8532 20.1667 17.6667 20.3532 17.6667 20.5833C17.6667 20.8134 17.8532 21 18.0833 21H22.0774L20.7053 22.372C20.5427 22.5347 20.5427 22.7986 20.7053 22.9613C20.8681 23.124 21.1319 23.124 21.2947 22.9613L23.378 20.878C23.5407 20.7152 23.5407 20.4514 23.378 20.2887L21.2947 18.2053C21.1319 18.0427 20.8681 18.0427 20.7053 18.2053C20.5427 18.3681 20.5427 18.6319 20.7053 18.7947L22.0774 20.1667H18.0833Z",
    fill: "#3F83F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/chart2.db35608a9f999edcaaf1ebe93a4e94ea.svg";
export { ForwardRef as ReactComponent };